<button [disabled]="!isAllowed" mat-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
<mat-menu #menu="matMenu">
    <ng-content></ng-content>
</mat-menu>